import { render, staticRenderFns } from "./GameNextButton.vue?vue&type=template&id=683f926b&scoped=true&"
import script from "./GameNextButton.vue?vue&type=script&lang=js&"
export * from "./GameNextButton.vue?vue&type=script&lang=js&"
import style0 from "./GameNextButton.vue?vue&type=style&index=0&id=683f926b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f926b",
  null
  
)

export default component.exports